import { TAGS } from 'modules/gallery';
import { Label, inputClass } from './ui';

export const emptyFields = {
	name: '',
	date: '',
	description: '',
	tags: [],
	pinned: false,
};

export const fieldsFromAlbum = (album) => ({
	name: album.name || '',
	date: album.date || '',
	description: album.description || '',
	tags: album.tags || [],
	pinned: Boolean(album.pinned),
});

export default ({ fields, onChange }) => {
	const set = (key, value) => onChange({ ...fields, [key]: value });

	const toggleTag = (tag) =>
		set(
			'tags',
			fields.tags.includes(tag)
				? fields.tags.filter((t) => t !== tag)
				: [...fields.tags, tag]
		);

	return (
		<div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
			<Label title='Name'>
				<input
					className={inputClass}
					value={fields.name}
					maxLength={200}
					onChange={(e) => set('name', e.target.value)}
					placeholder='Lamborghini STO'
				/>
			</Label>
			<Label title='Date (shown as typed)'>
				<input
					className={inputClass}
					value={fields.date}
					maxLength={40}
					onChange={(e) => set('date', e.target.value)}
					placeholder='Leave empty for today'
				/>
			</Label>
			<div className='sm:col-span-2'>
				<Label title='Description'>
					<textarea
						className={`${inputClass} min-h-[80px]`}
						value={fields.description}
						maxLength={2000}
						onChange={(e) => set('description', e.target.value)}
					/>
				</Label>
			</div>
			<div className='flex flex-col gap-1 text-sm'>
				<span className='opacity-70'>Tags</span>
				<div className='flex flex-row flex-wrap gap-2'>
					{TAGS.map((tag) => {
						const active = fields.tags.includes(tag);

						return (
							<button
								type='button'
								key={tag}
								aria-pressed={active}
								onClick={() => toggleTag(tag)}
								className={`rounded-full px-4 py-1 text-sm border border-borderContent ${
									active ? 'bg-fill text-background' : ''
								}`}>
								{tag}
							</button>
						);
					})}
				</div>
			</div>
			<label className='flex flex-row gap-2 place-items-center text-sm self-end'>
				<input
					type='checkbox'
					checked={fields.pinned}
					onChange={(e) => set('pinned', e.target.checked)}
				/>
				Pin to the top of the home page
			</label>
		</div>
	);
};
